import React, { useEffect, useRef, useState } from 'react';
import t from 'vivino-js/translationString';

import styles from './readMoreText.scss';

export enum READ_MORE_COLORS {
  COLOR_NOTE = 'note',
  COLOR_DEFAULT = 'defaultColor',
}

const translations = {
  readMore: 'components.deal_wine_page.read_more_text.read_more',
};

interface ReadMoreTextProps {
  text: string;
  maxHeight: number;
  colorType?: string;
  htmlInject?: boolean;
}

const ReadMoreText = ({
  text,
  htmlInject = false,
  maxHeight,
  colorType = READ_MORE_COLORS.COLOR_DEFAULT,
}: ReadMoreTextProps) => {
  const [isTextCollapsed, setIsTextCollapsed] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const height = ref.current.clientHeight;
    setIsTextCollapsed(height > maxHeight);
  }, [maxHeight]);

  function expandText() {
    setIsTextCollapsed(false);
  }

  function renderText() {
    const maxHeightValue = isTextCollapsed ? `${maxHeight}px` : 'none';

    if (htmlInject) {
      return (
        <div
          className={styles.text}
          style={{ maxHeight: maxHeightValue }}
          ref={ref}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      );
    }
    return (
      <div className={styles.text} style={{ maxHeight: maxHeightValue }} ref={ref}>
        {text}
      </div>
    );
  }

  return (
    <div className={`${styles.outer} ${styles[colorType]}`}>
      <div className={styles.textContainer}>
        {renderText()}
        {isTextCollapsed && (
          <div className={`${styles.fade} ${styles[colorType]}`} onClick={expandText} />
        )}
      </div>
      {isTextCollapsed && (
        <div className={styles.readMore} onClick={expandText}>
          {t(translations.readMore)}
        </div>
      )}
    </div>
  );
};

export default ReadMoreText;
